import * as React from 'react'
import type { SVGProps } from 'react'
export interface ClockIconProps extends SVGProps<SVGSVGElement> {
  size?: number | string
}
/**
 * clock
 * Tabler Icons
 * @url https://icon-sets.iconify.design/tabler
 * @license MIT
 */
export const ClockIcon = (props: ClockIconProps) => {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      width={props.size || '1em'}
      height={props.size || '1em'}
      {...props}
    >
      <g
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
      >
        <path d="M3 12a9 9 0 1 0 18 0a9 9 0 0 0-18 0" />
        <path d="M12 7v5l3 3" />
      </g>
    </svg>
  )
}
